import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-modal-layout" }
const _hoisted_2 = { class: "form-modal-layout__header" }
const _hoisted_3 = { class: "form-modal-layout__title" }
const _hoisted_4 = { class: "form-modal-layout__body scroll-wrapper" }
const _hoisted_5 = { class: "form-modal-layout__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button icon back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        type: "button"
      }),
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ]))
}